// Loads marketing trackers only after cookie consent (gdpr=1). Tracking IDs are
// set from app/views/shared/_google_analytics.html.erb and _hot_jar.html.erb.

function hasGdprConsent() {
  return document.cookie.split(';').some(function(item) {
    return item.trim().indexOf('gdpr=') === 0;
  });
}

function loadScriptOnce(flagName, src) {
  if (window[flagName]) {
    return;
  }
  window[flagName] = true;

  var script = document.createElement('script');
  script.async = true;
  script.src = src;
  var firstScript = document.getElementsByTagName('script')[0];
  firstScript.parentNode.insertBefore(script, firstScript);
}

function loadGoogleTagManager() {
  if (typeof window.WIDDYUP_GTM_ID !== 'string' || !window.WIDDYUP_GTM_ID) {
    return;
  }
  if (window.__widdyupGtmScriptRequested) {
    return;
  }

  window.__widdyupGtmScriptRequested = true;
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    'gtm.start': new Date().getTime(),
    event: 'gtm.js'
  });
  loadScriptOnce(
    '__widdyupGtmLoaderRequested',
    'https://www.googletagmanager.com/gtm.js?id=' + window.WIDDYUP_GTM_ID
  );
}

function loadGoogleTags() {
  if (!Array.isArray(window.WIDDYUP_GOOGLE_TAG_IDS) || window.WIDDYUP_GOOGLE_TAG_IDS.length === 0) {
    return;
  }

  window.dataLayer = window.dataLayer || [];
  window.gtag = window.gtag || function() {
    window.dataLayer.push(arguments);
  };

  if (!window.__widdyupGoogleTagsConfigured) {
    window.__widdyupGoogleTagsConfigured = true;
    window.gtag('js', new Date());
    window.WIDDYUP_GOOGLE_TAG_IDS.forEach(function(tagId) {
      window.gtag('config', tagId);
    });
  }

  loadScriptOnce(
    '__widdyupGoogleTagScriptRequested',
    'https://www.googletagmanager.com/gtag/js?id=' + window.WIDDYUP_GOOGLE_TAG_IDS[0]
  );
}

function loadHotjar() {
  if (!Array.isArray(window.WIDDYUP_HOTJAR_SITES) || window.WIDDYUP_HOTJAR_SITES.length === 0) {
    return;
  }

  window.WIDDYUP_HOTJAR_SITES.forEach(function(site) {
    if (!site || !site.id) {
      return;
    }

    var flagName = '__widdyupHotjarScriptRequested_' + site.id;
    if (window[flagName]) {
      return;
    }

    window.hj = window.hj || function() {
      (window.hj.q = window.hj.q || []).push(arguments);
    };
    window._hjSettings = {
      hjid: site.id,
      hjsv: site.version || 6
    };
    loadScriptOnce(
      flagName,
      'https://static.hotjar.com/c/hotjar-' + site.id + '.js?sv=' + window._hjSettings.hjsv
    );
  });
}

function ensureFbq() {
  if (window.fbq) {
    return;
  }

  /* eslint-disable */
  !function(f,b,e,v,n,t,s)
  {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
  n.callMethod.apply(n,arguments):n.queue.push(arguments)};
  if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
  n.queue=[];t=b.createElement(e);t.async=!0;
  t.src=v;s=b.getElementsByTagName(e)[0];
  s.parentNode.insertBefore(t,s)}(window, document,'script',
  'https://connect.facebook.net/en_US/fbevents.js');
  /* eslint-enable */
}

function syncMetaPixelWithConsent() {
  if (!hasGdprConsent()) {
    return;
  }
  if (typeof window.WIDDYUP_META_PIXEL_ID !== 'string' || !window.WIDDYUP_META_PIXEL_ID) {
    return;
  }

  ensureFbq();

  window.__widdyupMetaPixelIdsInitialized = window.__widdyupMetaPixelIdsInitialized || {};
  if (!window.__widdyupMetaPixelIdsInitialized[window.WIDDYUP_META_PIXEL_ID]) {
    window.fbq('init', window.WIDDYUP_META_PIXEL_ID);
    window.__widdyupMetaPixelIdsInitialized[window.WIDDYUP_META_PIXEL_ID] = true;
  }
  window.fbq('track', 'PageView');
}

// Fires a one-time CompleteRegistration on a specific pixel (the agency pixel)
// when the page declared window.WIDDYUP_COMPLETE_REGISTRATION. Uses trackSingle so
// only that pixel receives it, and eventID so Meta deduplicates it with the
// server-side Conversions API event that carries the same id.
function fireCompleteRegistrationWithConsent() {
  if (!hasGdprConsent()) {
    return;
  }

  var config = window.WIDDYUP_COMPLETE_REGISTRATION;
  if (!config || !config.pixelId || !config.eventId) {
    return;
  }
  if (window.__widdyupCompleteRegistrationFired) {
    return;
  }

  ensureFbq();

  window.__widdyupMetaPixelIdsInitialized = window.__widdyupMetaPixelIdsInitialized || {};
  if (!window.__widdyupMetaPixelIdsInitialized[config.pixelId]) {
    window.fbq('init', config.pixelId);
    window.__widdyupMetaPixelIdsInitialized[config.pixelId] = true;
  }

  window.fbq('trackSingle', config.pixelId, 'CompleteRegistration', {}, { eventID: config.eventId });
  window.__widdyupCompleteRegistrationFired = true;
}

function syncTrackingWithConsent() {
  if (!hasGdprConsent()) {
    return;
  }

  loadGoogleTagManager();
  loadGoogleTags();
  loadHotjar();
  syncMetaPixelWithConsent();
  fireCompleteRegistrationWithConsent();
}

$(document).on('turbolinks:load', syncTrackingWithConsent);

window.WiddyupMetaPixelConsent = {
  notifyConsentGranted: function() {
    syncTrackingWithConsent();
  }
};
